/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { ChipProps, getContrastRatio, useTheme } from "@mui/material";

//  Contrast Threshold für gute Lesbarkeit nach WCAG 2.0 Ref 1.4.3
const CONTRAST_THRESHOLD = 3;

export default function useVisibleChipColor(): ChipProps["color"] {
    const { palette } = useTheme();
    const chipColors: { [k: string]: string } = {
        primary: palette.primary.main,
        secondary: palette.secondary.main,
    };

    let chipColor: ChipProps["color"] = "secondary";
    if (getContrastRatio(chipColors[chipColor], palette.background.default) < CONTRAST_THRESHOLD) chipColor = "primary";
    if (getContrastRatio(chipColors[chipColor], palette.background.default) < CONTRAST_THRESHOLD) chipColor = "info";
    return chipColor;
}